import React from 'react';

import Score from '../Score/Score';

import './Header.scss';
import ScoreView from '../ScoreView/ScoreView';

const Header = ({ category, minified, isActive, isTitleBold }) => (
  <div
    className={`diagnostic-category-container ${
      isActive ? 'category-active-container' : ''
    }`}
    key={category.title}
  >
    <div
      className={`diagnostic-category-title ${
        isTitleBold ? 'diagnostic-category-title-bold' : ''
      }`}
    >
      {category.title}
    </div>
    {minified && <Score value={category.value} minified />}
    {!minified && <ScoreView category={category} />}
  </div>
);

export default Header;
